import React, { useContext, useState } from 'react'
import { Button, Modal, Spacer, TabMenu, TabMenuButton, Text, View } from 'oio-react'
import { Route, useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom'
import InitiativeCreate from 'src/apps/Initiative/apps/Create'
import InitiativeList from 'src/apps/Initiative/components/List'
import DiscussionListItemRow from 'src/apps/Discussions/components/ListItemRow'
import { useOrganization } from 'src/graphql/hooks'
import ThemeContext, { Theme } from 'src/libraries/contexts/Theme'

const FILTER_BY_RECENT = 'recent'
const FILTER_BY_POPULARITY = 'popularity'
const FILTER_BY_FOLLOWING = 'following'

const DiscussionsApp = () => {
   const history = useHistory()
   const location = useLocation()
   const { initiativeTypeSlug } = useParams()
   const match = useRouteMatch()
   const [modalIsOpen, setModalIsOpen] = useState(true)
   const theme = useContext(ThemeContext)
   const [initiativeListFilterMode, setInitiativeListFilterMode] = useState(FILTER_BY_RECENT)

   const { organization } = useOrganization()
   const initiativeType = organization.initiativeTypes.find(t => (
      t.slug === initiativeTypeSlug
   ))

   const initiativeListFilter = {
      drafts: 'include',
      limit: 25,
      sortBy: 'dateLastUpdated',
      typeIds: [initiativeType.id]
   }

   if (initiativeListFilterMode === FILTER_BY_POPULARITY) {
      initiativeListFilter.sortBy = 'popularity'
   } else if (initiativeListFilterMode === FILTER_BY_FOLLOWING) {
      initiativeListFilter.userRelationshipFilter = {
         userId: 'me',
         hasElementType: 'subscribed'
      }
   }

   return (
      <>
         <Theme globalNavBackgroundColor="transparent" />
         <View
            width="100%"
            height="100%"
            backgroundColor="#fff"
            scroll="on">
            <View display="flex[d-f]">
               <View
                  float="left"
                  backgroundColor="#fafafa"
                  width="100%[a-c] 35%[d-f]"
                  paddingVertical="20px[a-b] 50px[c-f]"
                  paddingRight="18px[a] 9vw[b] 6vw[c]">
                  <View
                     paddingLeft={theme.viewportPaddingLeft}
                     paddingRight="50px[d-f]">
                     <Text
                        size="8[a-b] 10[c-f]"
                        lineHeight="100%"
                        color="#000"
                        weight="medium">
                        {initiativeType.namePlural}
                     </Text>
                     <Spacer size="3" />
                     <Text size="4" weight="light" color="#666">
                        {'Participate in discussions in this Community. Ask a question from the Community, get some answers!'}
                     </Text>
                     <Spacer size="6" />
                     <Button
                        width="100%"
                        linkTo={`${match.url}/create`}
                        size="lg"
                        name={`+ New ${initiativeType.nameSingular}`}
                        color="#222"
                     />
                  </View>
               </View>
               <View
                  float="left"
                  width="100%[a-c] 65%[d-f]"
                  paddingVertical="20px[a-b] 40px[c-f]"
                  paddingLeft="18px[a] 9vw[b] 6vw[c]"
                  paddingRight={theme.viewportPaddingRight}
                  minHeight="100vh[d-f]">
                  <View paddingLeft="50px[d-f]">
                     <TabMenu
                        buttonSpacing="0px"
                        buttonSize="xl"
                        buttonTextSize="2"
                        highlightColor="#222">
                        <TabMenuButton
                           isActive={initiativeListFilterMode === FILTER_BY_RECENT}
                           onClick={() => setInitiativeListFilterMode(FILTER_BY_RECENT)}
                           name="Most Recent"
                        />
                        <TabMenuButton
                           isActive={initiativeListFilterMode === FILTER_BY_POPULARITY}
                           onClick={() => setInitiativeListFilterMode(FILTER_BY_POPULARITY)}
                           name="Most Popular"
                        />
                        <TabMenuButton
                           isActive={initiativeListFilterMode === FILTER_BY_FOLLOWING}
                           onClick={() => setInitiativeListFilterMode(FILTER_BY_FOLLOWING)}
                           name="Following"
                        />
                     </TabMenu>
                     <InitiativeList filter={initiativeListFilter}>
                        {initiativeList => initiativeList.items.map((initiative, index) => (
                           <DiscussionListItemRow
                              key={initiative.id}
                              addedBy={initiative.addedBy.fullName}
                              archived={initiative.archived}
                              backgroundColor={index % 2 ? 'transparent' : '#fafafa'}
                              borderStyle="none"
                              coverUrl={initiative.coverMedia?.file.thumbnailUrlW480}
                              dateLastUpdated={initiative.dateLastUpdated}
                              discussionFormat={initiative.discussionFormat}
                              discussionIsClosed={initiative.discussionStatus?.closed}
                              hasUnreadEntries={initiative.thread.hasUnreadEntries}
                              linkTo={{
                                 pathname: `/initiatives-new/${initiative.slug}`,
                                 state: { backgroundLocation: location }
                              }}
                              name={initiative.name}
                              numThreadEntries={initiative.thread.numEntries}
                              numViews={initiative.numViews}
                              pinned={initiative.pinned}
                              privacy={initiative.privacy}
                              slug={initiative.slug}
                              typeSlug={initiative.type.slug}
                           />
                        ))}
                     </InitiativeList>
                  </View>
               </View>
            </View>
            <Route path={`${match.path}/create`}>
               <Modal
                  borderRadius="5px"
                  width="300px[a-b] 480px[c-f]"
                  onCloseComplete={() => {
                     history.push(match.url)
                     setModalIsOpen(true)
                  }}
                  onCloseTrigger={() => setModalIsOpen(false)}
                  open={modalIsOpen}>
                  <InitiativeCreate
                     initiativeTypeId={initiativeType.id}
                     onCancelButtonClick={() => setModalIsOpen(false)}
                     onCloseTrigger={() => setModalIsOpen(false)}
                     onCreate={(initiative) => {
                        setModalIsOpen(true)
                        history.push(`/initiatives-new/${initiative.slug}/settings`)
                     }}
                  />
               </Modal>
            </Route>
         </View>
      </>
   )
}

export default DiscussionsApp
